import { render, staticRenderFns } from "./FormRatingInputGroup.vue?vue&type=template&id=88af6f26"
import script from "./FormRatingInputGroup.vue?vue&type=script&lang=js"
export * from "./FormRatingInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports